import { render, staticRenderFns } from "./importOrders.vue?vue&type=template&id=5acc5d54&scoped=true&"
import script from "./importOrders.vue?vue&type=script&lang=js&"
export * from "./importOrders.vue?vue&type=script&lang=js&"
import style0 from "./importOrders.vue?vue&type=style&index=0&id=5acc5d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acc5d54",
  null
  
)

export default component.exports